module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/assessment_achievements/4_5dd7bb88a11b9f8b442ebcff41650050.png";